export const downloadFile = (fileContent, fileName, mimeType) => {
  const url = window.URL.createObjectURL(new Blob([fileContent]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName); // Set the desired filename and extension
  document.body.appendChild(link);
  link.click();
  link.remove();
};
